import { withStyles } from "@material-ui/core/styles";
import Estado from "./Estado";
import styles from "./styles";

export default withStyles(styles)(Estado);
